interface FilterChipsProps {
  options: readonly string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterChips({ options, value, onChange }: FilterChipsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
              active
                ? "bg-primary-500 font-medium text-background-50"
                : "bg-secondary-100 text-secondary-800 hover:bg-secondary-200"
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}